export default __webpack_public_path__ + "static/media/dsv-ups-eu_fr.6060db5e.svg";